import { curry, isArray, map, mapValues } from 'lodash/fp';
/**
 * It runs map function over array or object
 * and returns result in same structure
 */

export var mapAdaptive = curry(function (func, data) {
  var mapFunc = isArray(data) ? map : mapValues;
  return mapFunc(func, data);
});
export default mapAdaptive;